import { Accordion, Text } from '@/ui'
import { OtherFeature } from '../SetupComplete'
import { AhaMomentsHeaderFooter } from './AhaMomentsHeaderFooter'
import { TypographyStyles } from '@/styles'

export const AhaMomentsBaseComponent = ({
  title,
  subtitle,
  description,
  features,
  media,
  learnMoreItems,
  backButtonText,
  continueButtonText,
  handleContinue,
  handleBack,
  continueDisabled,
}: {
  title: string
  subtitle: string
  description: React.ReactNode
  features: Array<{
    imgSrc: string
    title: string
    description: string | React.ReactNode
  }>
  media: React.ReactNode
  learnMoreItems: Array<{ title: string; content: React.ReactNode }>
  backButtonText: string
  continueButtonText: string
  handleContinue: () => void
  handleBack: () => void
  continueDisabled?: boolean
}) => (
  <AhaMomentsHeaderFooter
    backButtonText={backButtonText}
    continueButtonText={continueButtonText}
    handleContinue={handleContinue}
    handleBack={handleBack}
    continueDisabled={continueDisabled}
  >
    <div className="flex flex-col w-1/2 items-center mx-auto p-4">
      <Text variant={TypographyStyles.DISPLAY_MD} className="mt-8 mb-11">
        {title}
      </Text>

      {media && <div className="my-4">{media}</div>}

      <Text variant={TypographyStyles.H1} className="mb-6">
        {subtitle}
      </Text>

      <Text className="mb-8" variant={TypographyStyles.BODY_SM}>
        {description}
      </Text>

      <div className="flex flex-col gap-6 mb-8">
        {features.map((feature, index) => (
          <OtherFeature
            key={index}
            imgSrc={feature.imgSrc}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>

      <div className=" w-full text-center">
        <Text variant={TypographyStyles.H3} className="mb-4">
          Learn more
        </Text>
        <Accordion type="multiple" variant="text" items={learnMoreItems} />
      </div>
    </div>
  </AhaMomentsHeaderFooter>
)
